package com.essntl.features.paymentlink.data.supabase

import com.essntl.features.paymentlink.domain.model.PaymentLinkModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun PaymentLinkModel.toRequestMap(): Map<String, JsonElement> {
    val paymentLinkMap = mutableMapOf<String, JsonElement>()

    if (!linkUrl.isNullOrEmpty()) {
        paymentLinkMap["link_url"] = JsonPrimitive(linkUrl)
    }

    if (!proposalId.isNullOrEmpty()) {
        paymentLinkMap["proposal_id"] = JsonPrimitive(proposalId)
    }

    if (!linkId.isNullOrEmpty()) {
        paymentLinkMap["link_id"] = JsonPrimitive(linkId)
    }

    if (!productName.isNullOrEmpty()) {
        paymentLinkMap["product_name"] = JsonPrimitive(productName)
    }

    if (amount != null) {
        paymentLinkMap["amount"] = JsonPrimitive(amount)
    }

    if (hasMerchantFee != null) {
        paymentLinkMap["has_merchant_fee"] = JsonPrimitive(hasMerchantFee)
    }

    if (active != null) {
        paymentLinkMap["active"] = JsonPrimitive(active)
    }

    return paymentLinkMap
}
